export default __webpack_public_path__ + "static/media/delete-tab-icon.a9697f65.svg";